<template>
  <div class="selectable-rows is-shallow">
    <slot
      :selectable-rows="
        selectables.map((s) => ({ item: s.object, selected: s.selected }))
      "
      :toggle-select-row="toggleSelect"
      :toggle-select-all-rows="toggleSelectAll"
      :all-rows-selected="allSelected"
    ></slot>
  </div>
</template>

<script>
import { toRef } from 'vue'
import { useSelectableRecords } from '@/composables/useSelectableRecords'

export default {
  name: 'SelectableRows',
  emits: ['selected-indices', 'last-selected'],
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const {
      selectables,
      selectedIndices,
      toggleSelect,
      toggleSelectAll,
      allSelected,
    } = useSelectableRecords(toRef(props, 'rows'))

    return {
      selectables,
      selectedIndices,
      toggleSelect,
      toggleSelectAll,
      allSelected,
    }
  },
  watch: {
    selectedIndices: {
      handler(s) {
        this.$emit('selected-indices', s)
      },
      immediate: true,
    },
  },
}
</script>

<style scoped>
.selectable-rows.is-shallow {
  display: contents;
}
</style>
